import { render, staticRenderFns } from "./NoFooterModal.vue?vue&type=template&id=53414a06&scoped=true"
import script from "./NoFooterModal.vue?vue&type=script&lang=js"
export * from "./NoFooterModal.vue?vue&type=script&lang=js"
import style0 from "./NoFooterModal.vue?vue&type=style&index=0&id=53414a06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53414a06",
  null
  
)

export default component.exports